import { render, staticRenderFns } from "./HealthPresentModal.vue?vue&type=template&id=7fc147cf&scoped=true"
import script from "./HealthPresentModal.vue?vue&type=script&lang=js"
export * from "./HealthPresentModal.vue?vue&type=script&lang=js"
import style0 from "./HealthPresentModal.vue?vue&type=style&index=0&id=7fc147cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc147cf",
  null
  
)

export default component.exports